export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20environment%20with%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20abstract%20film%20reel%20texture%20overlay%2C%20soft%20bokeh%20effects%2C%20elegant%20atmospheric%20background%20for%20movie%20streaming%20website%2C%20luxurious%20cinema%20aesthetic%2C%20dark%20gradient%20with%20subtle%20golden%20accents%2C%20no%20text%20no%20logos%20no%20recognizable%20faces&width=1920&height=1080&seq=hero-bg-movie-01&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs font-medium tracking-wider mb-5 whitespace-nowrap">
              每日更新 · 高清片源 · 流畅不缓冲
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-5">
              555影视 · 最新高清电影
              <br className="hidden sm:block" />
              免费在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-white/70 font-light mb-4">
              追影不等待，好片即刻看
            </p>

            <p className="text-white/55 text-sm md:text-base leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              555影视为您精选最新电影、高清电影大全，涵盖动作、喜剧、科幻、悬疑、动画等全类型片库。每日同步更新热门大片与经典佳作，高清片源配合流畅播放技术，无需缓冲等待，让您随时随地畅享极致观影体验。无论您想追最新上映的热门巨制，还是重温令人难忘的影史经典，555影视都是您最贴心的免费在线看电影首选平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">20000+</div>
                <div className="text-white/45 text-xs mt-1">高清片源覆盖</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-white/45 text-xs mt-1">同步全网最新</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">流畅不缓冲</div>
                <div className="text-white/45 text-xs mt-1">极速播放体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleClick(e, '#carousel')}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-movie-2-line"></i>
                探索专题
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/10 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/20 transition-colors backdrop-blur-sm"
              >
                <i className="ri-fire-line"></i>
                热门榜单
              </a>
            </div>
          </div>

          <div className="hidden lg:block flex-shrink-0 w-[380px] xl:w-[440px]">
            <div className="relative rounded-2xl overflow-hidden aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20poster%20composition%20featuring%20abstract%20film%20elements%20like%20glowing%20film%20reels%20and%20spotlight%20beams%20on%20a%20dark%20warm%20background%2C%20elegant%20golden%20and%20crimson%20color%20scheme%2C%20artistic%20movie%20atmosphere%2C%20no%20text%20no%20faces%20no%20logos%2C%20luxurious%20cinema%20aesthetic%20with%20soft%20lighting%20effects&width=880&height=1174&seq=hero-visual-movie-02&orientation=portrait"
                alt="555影视电影主题视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}